<template>
    <v-layout row wrap class="edit-profile__container">
        <v-layout row wrap class="edit-profile__details">
            <v-flex sm4 xs3 text-xs-left class="edit-profile__details__image">
                <!-- TODO: will uncomment below lines once we will confirm how to calculate profile percentage -->
                <!-- <v-progress-circular :rotate="-90" :value=profileInformation.percentageProfileComplete :size="100" :width="8" background-color="white" color="ypo_gold" data-qe-id="myProfileEditLink_profileImage" @click="openMemberProfile()"> -->
                <v-avatar size="85">
                    <img class="hover"
                         data-qe-id="my-profile_avatar"
                         @click="openMemberProfile()"
                         :src="sizeFormattedImageUrl(profileImageComputed, 150, 150)"
                         :alt="profileImage && profileImage.userName ? profileImage.userName : 'My Profile'"
                         @error="profileImageFailHandler">
                </v-avatar>
                <!-- </v-progress-circular> -->
            </v-flex>
            <v-flex sm8 xs9 class="edit-profile__details__profile">
            <v-flex class="edit-profile__back text-xs-left">Welcome Back,</v-flex>
            <v-flex
                @click="openMemberProfile()"
                tag="span"
                class="edit-profile__name hover"
                data-qe-id="myProfileEditLink_profileName">
                {{getuserProfileName}}
            </v-flex>
            <v-flex tag="span" class="edit-profile__status">
                <!-- {{profileInformation.percentageProfileComplete}}{{myAccountConstants.myProfileConstants.PROFILE_COMPLETE}} -->
            </v-flex>
            <v-flex text-xs-left>
                <v-btn v-if="!isSpeakerView" @click="openMemberProfile()" class="edit-profile__details__btn" data-qe-id="myProfileEditLink_profileEditBtn">
                    {{myAccountConstants.EDIT_PROFILE}}
                </v-btn>
            </v-flex>
            <v-flex v-if="getYPOMemberId" class="ypo-member-id mt-2">{{myAccountConstants.YPO_MEMBER_ID}}
                <v-flex class="ypo-member-id__value">{{getYPOMemberId}}</v-flex>
            </v-flex>
            </v-flex>
        </v-layout>
        <v-flex class="edit-profile__details__info inner-scrollbar" id="MyAccountMenu">
            <v-card>
                <v-list class="menu">
                    <v-flex class="menuLists">
                        <v-expansion-panel v-click-outside="none" v-model="menuPanel">
                            <v-expansion-panel-content
                                v-for="(myAccountConstant, index) in myAccountConstants.menu"
                                :key="myAccountConstant.key"
                                v-if="isSpeakerView ? myAccountConstant.showForExternalSpeaker : myAccountConstant.showForMember"
                                :data-qe-id="'accountMenu_' + index"
                                hide-actions
                                class="v-expansion-panel__container__main">
                                <div
                                    v-if="!myAccountConstant.url"
                                    slot="header"
                                    @click="toggle"
                                    class="my-account">{{myAccountConstant.title}}</div>
                                <a
                                    :target="linkTarget(myAccountConstant)"
                                    v-if="myAccountConstant.url"
                                    slot="header"
                                    :data-qe-id="`account-url_${index}`"
                                    class="my-account hyperlink"
                                    @click="hideSideBar(myAccountConstant)"
                                    :href="isSpeakerView ? resourceDirectoryUrl(myAccountConstant) : myAccountConstant.url">
                                    {{myAccountConstant.title}}</a>
                                <v-card class="menuLists__submenu" v-if="myAccountConstant.componentName">
                                    <component :is="myAccountConstant.componentName" />
                                </v-card>
                                <v-expansion-panel v-if="!myAccountConstant.componentName" v-model="subMenuPanel" class="menuLists__submenu">
                                    <v-expansion-panel-content
                                        v-for="(subMenuItem, index) in myAccountConstant.subMenu"
                                        :key="subMenuItem.key"
                                        :data-qe-id="`accountMenu_sub-menu_${index}`"
                                        hide-actions
                                        v-if="myAccountConstant.subMenu && displayInMobileApp(subMenuItem) && canViewM2mx(subMenuItem)"
                                        :class="subMenuItem.url ? 'url-links' : ''">
                                        <div v-if="subMenuItem.componentName"
                                             :data-qe-id="`accountMenu_sub-menu_${index}-toggle`"
                                             slot="header"
                                             @click="toggle">
                                            {{subMenuItem.title}}
                                        </div>
                                        <a :target="subMenuItemTarget(subMenuItem)"
                                           v-if="!subMenuItem.componentName"
                                           slot="header"
                                           :data-qe-id="`accountMenu_sub-menu_${index}-title`"
                                           @click="getUrl(subMenuItem)">
                                            {{subMenuItem.title}}
                                        </a>
                                        <v-card class="" v-if="subMenuItem.componentName">
                                            <component :is="subMenuItem.componentName" :register-on-close="registerOnClose" />
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>
                    <v-flex xs12 class="log-out">
                        <v-btn class="primary_btn" @click="logout()" data-qe-id="account_logoutBtn">
                            {{myAccountConstants.LOG_OUT}} <v-icon>fas fa-sign-out-alt</v-icon>
                        </v-btn>
                    </v-flex>
                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import { myAccountConstants, userProfileName, userTypes } from "./myaccount.constants.js";
import ChangeUsername from "./ChangeUsername";
import ChangePassword from "./ChangePassword";
import ManageLoginSecurity from "./ManageLoginSecurity";
import MyProfile from "./MyProfile.vue";
import ClickOutside from "vue-click-outside";
import ContactUs from "./ContactUs";
import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";
import { communityCommonConstant } from "../ChapterPage/communityCommon.constant";
import { routerNames } from "../appCommon.constants";
import { appConstant } from '../../app.constant';
import { imageErrorFallback } from "../../common/utils/utils";
import { getToken, deleteToken } from 'firebase/messaging';
import 'firebase/messaging';

export default {
    name: "MyAccount",
    data: () => ({
        myAccountConstants,
        communityCommonConstant,
        routerNames,
        menuPanel: [],
        subMenuPanel: [],
        onClosedActions: [],
        myAccountUrls: [],
        profileImageFailureFlags: {},
        sizeFormattedImageUrl,
    }),
    components: {
        ChangeUsername,
        ChangePassword,
        ManageLoginSecurity,
        ContactUs,
        MyProfile,
    },
    props: {
        hideSideBars: {
            type: Function,
            required: true,
        },
    },
    created() {
        this.getCurrentUserId();
        this.getResourceLinks();
    },
    methods: {
        ...mapActions({
            submitLogout: `auth/${storeAction.submitLogout}`,
            getCurrentUserId: `memberProfile/${storeAction.getCurrentUserId}`,
            deletePersonFcmToken: `notification/${storeAction.deletePersonFcmToken}`,
            getResourceLinks: `tools/${storeAction.getResourceLinks}`,
        }),
        imageErrorFallback,

         resourceDirectoryUrl(name) {
            if (this.termsPrivacyURLs && name !== "") {
                const termsOfUseUrl = this.termsPrivacyURLs.find(item => item.name.toLowerCase() === name.title.toLowerCase());
                return termsOfUseUrl.navigationUrl;
            }
            return "";
        },
        hideSideBar(menuItem) {
            if (menuItem.key === 'privacySettings') {
                this.hideCollapseSidebar();
            }
        },
        getUrl(subMenuItem) {
            if (subMenuItem.routeName) {
                this.hideCollapseSidebar();
                this.subMenuItemHref(subMenuItem);
            } else if (subMenuItem.url) {
                this.hideCollapseSidebar();
                window.open(subMenuItem.url, this.isMobileAppBrowser ? '_self' : '_blank');
            } else {
                const triggeredItem = this.myAccountUrls.find(item => item.name === subMenuItem.title);
                if (triggeredItem) {
                    window.open(triggeredItem.url, this.isMobileAppBrowser ? '_self' : '_blank');
                }
            }
        },
        async logout() {
          if (this.isMobileAppBrowser) {
            if (window && window.appInterface) {
              const androidInterface = window.appInterface;
              androidInterface.logout();
            } else if (window && window.webkit && window.webkit.messageHandlers) {
              const iosInterface = window.webkit.messageHandlers.logout;
              iosInterface.postMessage("");
            }
          } else {
            if (localStorage.getItem(appConstant.DEFAULT_IS_FIREBASE_SUPPORTED) === appConstant.DEFAULT_FIREBASE_SUPPORTED_TRUE
                && Notification.permission === 'granted') {
              await this.removePersonFcmToken(this.currentUserId);
            }
            caches.delete('MyRecommendedEvents');
            this.submitLogout();
          }
        },
        async removePersonFcmToken(personId) {
          const messaging = this.$messaging;
          const currentToken = await getToken(messaging);
          if (currentToken) {
            const tokenObject = {};
            tokenObject.PersonId = personId;
            tokenObject.FcmToken = currentToken;
            await this.deletePersonFcmToken(tokenObject);
            await deleteToken(messaging).then(() => {
            }).catch((error) => {
              console.error('Failed to delete the token', error);
            });
            await this.unregisterServiceWorker();
          }
        },
        async unregisterServiceWorker() {
          if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (let registration of registrations) {
              if (registration.active) {
                await registration.unregister();
              }
            }
          }
        },
        openMemberProfile() {
            this.hideSideBars();
            if (!this.isSpeakerView) {
                this.$router.push({
                    path: '/memberProfile',
                    query: {
                        memberId: this.currentUserId,
                        mode: this.routerNames.EDIT,
                    },
                });
            }
        },
        subMenuItemHref(subMenuItem) {
            if (subMenuItem.parent) {
                this.$router.push({
                path: `/${subMenuItem.parent}/${subMenuItem.routeName}`,
                });
            } else {
                this.$router.push({
                path: `/${subMenuItem.routeName}`,
                });
            }
        },
        subMenuItemTarget(subMenuItem) {
            return subMenuItem.url ? "_blank" : "";
        },
        openComponent() {
            this.hideSideBars();
            this.$router.push("/MyProfile");
        },
        none() {
            this.subMenuPanel = -1;
            this.menuPanel = -1;
            this.onClosedActions.forEach(cb => cb());
        },
        toggle() {
            this.subMenuPanel = -1;
            this.onClosedActions.forEach(cb => cb());
        },
        registerOnClose(cb) {
            this.onClosedActions.push(cb);
        },
        hideCollapseSidebar() {
            this.none();
            this.hideSideBars();
        },
        profileImageFailHandler() {
            const desiredImage = this.profileImageUrlWithTimestamp;
            this.profileImageFailureFlags = {
                ...this.profileImageFailureFlags,
                [desiredImage]: true,
            };
        },
        displayInMobileApp(menuItem) {
            let result = true;
            if (menuItem && menuItem.hasOwnProperty('showInMobileApp') && this.isMobileAppBrowser) {
                result = menuItem.showInMobileApp;
            }
            return result;
        },
        linkTarget(linkItem) {
            return (linkItem.key === 'm2mx' && this.isMobileAppBrowser)
            || linkItem.key === 'privacySettings' ? '_self' : '_blank';
        },
        canViewM2mx(menuItem) {
            let result = true;
            if (menuItem && (menuItem.key === this.myAccountConstants.UPDATE_M2MX_PROFILE || menuItem.key === this.myAccountConstants.REQUEST_ASSISTANCE)) {
                result = this.profileInformation && this.profileInformation.recordTypeName && (this.profileInformation.recordTypeName === userTypes.MEMBER
                || this.profileInformation.recordTypeName === userTypes.SPOUSE_PARTNER);
            }
            return result;
        },
    },
    computed: {
        ...mapGetters({
            profileInformation: `myAccount/${storeGetters.profileInformation}`,
            currentUserId: `memberProfile/${storeGetters.currentUserId}`,
            profileImage: `myAccount/${storeGetters.profileImage}`,
            resourceLinks: `tools/${storeGetters.resourceLinks}`,
            isSpeakerView: `auth/${storeGetters.isSpeakerView}`,
            isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            termsPrivacyURLs: `openAPI/${storeGetters.termsPrivacyURLs}`,
        }),
        getuserProfileName() {
            return userProfileName(this.profileInformation);
        },
        getYPOMemberId() {
            return this.profileInformation && this.profileInformation.membershipId ? this.profileInformation.membershipId : '';
        },
        profileImageUrlWithTimestamp() {
            return this.profileImage && this.profileImage.originalImage
                ? `${this.profileImage.originalImage}`
                : null;
        },
        profileImageComputed() {
            const desiredImage = this.profileImageUrlWithTimestamp;
            if (this.profileImageFailureFlags[desiredImage]) {
                return this.profileImage && this.profileImage.fallBackImage
                    ? this.profileImage.fallBackImage
                    : '';
            }
            return desiredImage;
        },
    },
    watch: {
        resourceLinks(val) {
            if (val) {
            val.forEach((element) => {
                element.forEach((subElement) => {
                    if (subElement.resourceCenterCategoryName === this.myAccountConstants.My_ACCOUNT) {
                        this.myAccountUrls.push(subElement);
                    }
                });
            });
            }
        },
    },
    directives: {
        ClickOutside,
    },
};
</script>

<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.menu {
    background-color: $white;
    padding: 0;

    .menuLists {
        border-bottom: 1px solid rgba($ypo-medium-gray, 0.3);

        .v-expansion-panel {
            box-shadow: none;

            &__container {
                border: none;

                &__main {
                    position: relative;
                    transition: 2s;
                }

                .v-expansion-panel__header {
                    padding: 13px;
                    min-height: inherit;
                    position: relative;
                    border-bottom: 1px solid $ypo-extra-light-gray;
                    background: $white;
                }
                .v-expansion-panel__body {
                    background: rgba($ypo-cta, 0.03)
                }

                &--active {
                    position: relative;

                    &.url-links {
                        //padding: 5px 30px 10px 30px;
                        background: transparent;
                    }
                }
            }
        }

        .v-list__group--active {
            background: $ypo-extra-light-gray;
        }

        &__submenu {
            cursor: default;
            box-shadow: none;

            .v-expansion-panel__container {
                border-top: none;
                background: transparent;
                cursor: default;
                padding: 5px 30px;

                .v-expansion-panel__header {
                    padding: 0;
                    margin: 5px 0;
                    font-size: 14px;
                    min-height: inherit;
                    color: $ypo-dark-background-gray;
                    display: inline-block;
                    background: transparent;
                    border: none;
                    font-weight: 500;


                    &:hover {
                        color: $ypo_blue;
                    }

                    a {
                        font-size: 14px;
                        color: $ypo-dark-background-gray;
                        text-decoration: none;

                        &:hover {
                            color: $ypo-cta;
                        }
                    }
                }
                .v-expansion-panel__body {
                    background: transparent;
                }

                &--active {
                    //padding: 15px 30px 0px 30px;

                    .v-expansion-panel__header {
                        color: $ypo_blue;
                        font-size: 14px;
                        font-weight: 600;
                    }
                }
            }
        }

        .v-icon {
            font-size: 20px;
        }
    }

    .my-account {
        font-size: 14px;
        color: $ypo-cta;
        font-weight: 600;
        margin: 0 10px;

        &__sub {
            font-size: 14px;
            text-transform: capitalize;
            padding-left: 30px;
            color: $ypo-title-blue-gray;
        }
    }

    .hyperlink {
        text-decoration: none;
    }

    .log-out {
        margin-top: 15px;
        padding: 0;
        text-align: center;

        .v-icon {
            opacity: 1;
            font-size: 20px;
            margin-left: 10px;
            color: $white;
        }

        .v-btn {
            font-size: 16px;
            padding: 26px 20px;
            width: 100%;
            margin: 0;
            border-radius: 0;
        }

        &:hover {
            background: $ypo-cta;
        }
    }
}

.hover {
    cursor: pointer;
}

.v-progress-circular__underlay {
    stroke: $white;
}

.ypo-member-id {
    text-transform: none;
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #083050;
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    &__value {
    color: #44779f;
    display: inline-block;
    }

}
</style>
